module.exports = __webpack_public_path__ + "static/media/arrow-circle-down-outline.50902cd0.svg";